import { render, staticRenderFns } from "./choosewechat.vue?vue&type=template&id=c97275b6&scoped=true"
import script from "./choosewechat.vue?vue&type=script&lang=js"
export * from "./choosewechat.vue?vue&type=script&lang=js"
import style0 from "./choosewechat.vue?vue&type=style&index=0&id=c97275b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97275b6",
  null
  
)

export default component.exports